import { experimentClient } from "core/experiment/experimentClient";

export interface VariantResult {
  value: string | undefined;
  fromUrlOverride: boolean;
}

export abstract class AmplitudeExperimentDataSource {
  abstract getVariant(experimentKey: string): VariantResult;
}

export class AmplitudeExperimentDataSourceImpl extends AmplitudeExperimentDataSource {
  getVariant(experimentKey: string): VariantResult {
    const search = typeof window !== "undefined" ? window.location.search : "";
    const params = new URLSearchParams(search);
    const overrideKey = `exp-${experimentKey}`;

    let hasAnyExperimentOverride = false;
    let variantValueOverride: string | undefined;

    for (const [paramKey, paramValue] of params.entries()) {
      if (paramKey.startsWith("exp-")) {
        hasAnyExperimentOverride = true;
        if (paramKey === overrideKey) {
          variantValueOverride = paramValue;
        }
      }
    }

    // URL override: return the forced value and skip Amplitude lookup entirely.
    // Exposure is NOT tracked when a URL override is active — suppresses QA traffic
    // from polluting experiment data in Amplitude.
    if (variantValueOverride !== undefined) {
      return { value: variantValueOverride, fromUrlOverride: true };
    }

    const client = experimentClient.getInstance();
    if (!client) {
      return { value: undefined, fromUrlOverride: false };
    }

    const variant = client.variant(experimentKey);

    if (variant?.value) {
      // Only fire exposure event when no exp-* params are present anywhere in the URL.
      if (!hasAnyExperimentOverride) {
        client.exposure(experimentKey);
      }
      return { value: variant.value, fromUrlOverride: false };
    }

    return { value: undefined, fromUrlOverride: false };
  }
}
